import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import 'lib-flexible'
import 'element-plus/dist/index.css'
import axios from '@/common/axios'
import LisuanMarketing from './views/lisuanMarketing.vue'
const app = createApp(App)
app.config.globalProperties.$http = axios

// createApp(App).use(store).use(router).mount('#app')
const marketingPath = window.location.pathname.replace(/\/+$/, '')
if (marketingPath === '/H4sRHDmn14k') {
  createApp(LisuanMarketing).mount('#app')
} else {
  import('./router').then(({ default: router }) => {
    app.use(store).use(router).mount('#app')
  })
}
